import React, { Component } from 'react'
import AutoBind from 'react-autobind';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import Moment from 'Moment';
import { FormGroup } from './../../util/form-group/index';
import Modal from './../../util/modal/index';
//import ReactSelect, { components } from 'react-select'; 
import {
    Consulta_Cola_Venta_Credito_Fiscal, Aplicar_Cola_Venta_Credito_Fiscal, Aplicar_Todo_Cola_Venta_Credito_Fiscal, Consulta_Cancelaciones, Consulta_Nota_Credito, Factura_Credito_IndividualSoloUna
} from '../../request/rfc';
const FormatDateCR = 'DD/MM/YYYY';
const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};


export default class Bitacora extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            selectedRow: {},
            disabled: false,
            isChecked: false,
            MasterChecked: false,
            SelectedList: {},
            fechaInicio: '',
            fechaFinal: '',
            fechaInicioAux: '',
            fechaFinalAux: '',
            estiloFactura: false,
            estiloCancelacion: false,
            estiloNota: false,
        };
        localStorage.setItem("tipoFactura", '')
        AutoBind(this);
    }

    componentDidMount() {
        this.cargar_Cola_Venta_Credito_Fiscal();
        //this.initTableCancelaciones([]);
        //this.initTableNotaCredito([]);
        const $table = $(this.refs.tblFacturas);
        $table.on('click-row.bs.table', this.onClickTable);
        //$table.on('click-row.bs.table', this.checkedAplicar);
        this.setState({
            fechaInicio: Moment().subtract(7, 'days').format('DD/MM/YYYY'),
            fechaFinal: Moment().format('DD/MM/YYYY')
        })
        this.onchangeFechas();
    }

    componentWillUnmount() {
        // validar lo de las fechas, para destruir el componente
        $(document.getElementById('fechaInicio')).datepicker('destroy');
        $(document.getElementById('fechaFinal')).datepicker('destroy');
    }
    
    cargar_Cola_Venta_Credito_Fiscal() {
        const { fechaInicioAux, fechaFinalAux } = this.state;
        Consulta_Cola_Venta_Credito_Fiscal({ pFechaInicio: (fechaInicioAux === '' ? Moment().format('L') : fechaInicioAux), pFechaFinal: (fechaFinalAux === '' ? Moment().format('L') : fechaFinalAux) })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ SelectedList: Data, estiloFactura: true, estiloCancelacion: false, estiloNota: false });
                    const data = Data.map(item => Object.assign({}, item, { Fecha_Apertura: Moment(item.Fecha_Apertura).format(FormatDateCR) }));
                    this.initTable([]);
                    this.loadTable(data);
                }
            })
            .catch((err) => { console.log(err); });
    }
    
    cargar_Cancelaciones() {
        const { fechaInicioAux, fechaFinalAux } = this.state;
        console.log(fechaInicioAux, fechaFinalAux)
        Consulta_Cancelaciones({ pFechaInicio: (fechaInicioAux === '' ? Moment().format('L') : fechaInicioAux), pFechaFinal: (fechaFinalAux === '' ? Moment().format('L') : fechaFinalAux) })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ SelectedList: Data, estiloFactura: false, estiloCancelacion: true, estiloNota: false });
                    const data = Data.map(item => Object.assign({}, item, { Fecha_Apertura: Moment(item.Fecha_Apertura).format(FormatDateCR) }));
                    this.initTableCancelacion([]);

                    this.loadTableCancelacion(data);
                }
            })
            .catch((err) => { console.log(err); });
    }

    initTable(data) {
        const $table = $(this.refs.tblFacturas);
        let _columnas = [];
        _columnas = [{
            title: 'Marcar',
            formatter: function (value, row, index) {
                return '<input type="checkbox" name="Checkbox" id="' + row.Documento +'" value="false" />'
            }
        },{
            title: 'Sucursal',
            field: 'Suc_Id',
            sortable: true
        }, {
            title: 'Documento',
                field: 'Documento'
        }, {
            title: 'Cliente',
            field: 'Cliente_Id',
            sortable: true
            }, {
                title: 'Fecha',
                field: 'Factura_Fecha',
                sortable: true
            }, {
                title: 'Total',
                field: 'Factura_Total',
                cellStyle: function cellStyle(value, row, index, field) {
                    return {
                        css: { "text-align": "right" }
                    };
                }
                
            }, {
                title: 'Mensaje',
                field: 'Fiscal_MensajeError',
                sortable: true
            }, {
                title: 'Estado',
                field: 'Estado',
                sortable: true
            }];
        $table.bootstrapTable('destroy');

        $table.bootstrapTable({
            data: data || [],
            cache: false,
            height: 550,
            striped: false,
            pagination: true,
            sortable: true,
            locale: 'es-Ar',
            sortOrder: 'asc',
            showToggle: false,
            showPaginationSwitch: false,
            pageSize: 10,
            pageList: [10, 20, 30, 150, 250, 350, 500],
            search: true,
            toolbar: $('#toolbar'),
            toolbarAlign: 'right',
            showColumns: false,
            showRefresh: false,
            minimumCountColumns: 3,
            clickToSelect: true,
            rowAttributes: function (row) {
                return { 'data-id': row.Documento }

            },
            columns: _columnas
        });
    }

    loadTable(data) {
        const $table = $(this.refs.tblFacturas);
        $table.bootstrapTable('load', data || []);
    }

    initTableCancelacion(data) {

        const $table = $(this.refs.tblCancelaciones);
        let _columnas = [];
        _columnas = [{
            title: 'Marcar',
            formatter: function (value, row, index) {
                return '<input type="checkbox" name="Checkbox" id="' + row.Documento + '" value="false" />'
            }
        }, {
            title: 'Sucursal',
            field: 'Suc_Id',
            sortable: true
        }, {
            title: 'Número Factura',
                field: 'Fiscal_NumeroFactura',
            sortable: true
        }, {
            title: 'Motivo Cancelación',
                field: 'RegimenFiscalMotivoCancelacion',
            sortable: true
        }, {
            title: 'Fecha',
            field: 'Fecha',
                sortable: true
        }, {
            title: 'Respuesta',
                field: 'Respuesta',
            sortable: true
        }];
        $table.bootstrapTable('destroy');

        $table.bootstrapTable({
            data: data || [],
            cache: false,
            height: 550,
            striped: false,
            pagination: true,
            sortable: true,
            locale: 'es-Ar',
            sortOrder: 'asc',
            showToggle: false,
            showPaginationSwitch: false,
            pageSize: 10,
            pageList: [10, 20, 30, 150, 250, 350, 500],
            search: true,
            toolbar: $('#toolbar'),
            toolbarAlign: 'right',
            showColumns: false,
            showRefresh: false,
            minimumCountColumns: 3,
            clickToSelect: true,
            rowAttributes: function (row) {
                return { 'data-id': row.Bitacora_Id }

            },
            columns: _columnas
        });
    }

    loadTableCancelacion(data) {
        const $table = $(this.refs.tblCancelaciones);
        $table.bootstrapTable('load', data || []);
    }

    cargar_Nota_Credito() {
        const { fechaInicioAux, fechaFinalAux } = this.state;
        Consulta_Nota_Credito({ pFechaInicio: (fechaInicioAux === '' ? Moment().format('L') : fechaInicioAux), pFechaFinal: (fechaFinalAux === '' ? Moment().format('L') : fechaFinalAux) })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.setState({ SelectedList: Data, estiloFactura: false, estiloCancelacion: false, estiloNota: true });
                    const data = Data.map(item => Object.assign({}, item));
                    this.initTableNotaCredito([]);

                    this.loadTableNotaCredito(data);
                }
            })
            .catch((err) => { console.log(err); });
    }

    initTableNotaCredito(data) {

        const $table = $(this.refs.tblNotaCredito);
        let _columnas = [];
        _columnas = [{
            title: 'Marcar',
            formatter: function (value, row, index) {
                return '<input type="checkbox" name="Checkbox" id="' + row.Documento + '" value="false" />'
            }
        }, {
            title: 'Sucursal',
            field: 'Suc_Id',
            sortable: true
        }, {
                title: 'Factura',
                field: 'Factura_Id'
        }, {
            title: 'Cliente',
            field: 'Cliente_Id',
            sortable: true
        }, {
            title: 'Fecha',
            field: 'Fecha',
            sortable: true
        },  {
                title: 'UUID',
                field: 'Fiscal_UUID',
            sortable: true
        }, {
                title: 'Factura Referencia',
                field: 'Fiscal_NumeroFactura_Referencia',
            sortable: true
            }, {
                title: 'Fecha Generación',
                field: 'Fecha_Generacion',
                sortable: true
            }, {
                title: 'NC UUID',
                field: 'NC_UUID',
                sortable: true
            }, {
                title: 'Número Factura NC',
                field: 'NC_NumeroFactura',
                sortable: true
            }, {
                title: 'Mensaje Error',
                field: 'MensajeError',
                sortable: true
         }];

        
        
        
        
        $table.bootstrapTable('destroy');

        $table.bootstrapTable({
            data: data || [],
            cache: false,
            height: 550,
            striped: false,
            pagination: true,
            sortable: true,
            locale: 'es-Ar',
            sortOrder: 'asc',
            showToggle: false,
            showPaginationSwitch: false,
            pageSize: 10,
            pageList: [10, 20, 30, 150, 250, 350, 500],
            search: true,
            toolbar: $('#toolbar'),
            toolbarAlign: 'right',
            showColumns: false,
            showRefresh: false,
            minimumCountColumns: 3,
            clickToSelect: true,
            rowAttributes: function (row) {
                return { 'data-id': row.Cola_Id }

            },
            columns: _columnas
        });
    }

    loadTableNotaCredito(data) {
        const $table = $(this.refs.tblNotaCredito);
        $table.bootstrapTable('load', data || []);
    }

    onchangeFechas() {

        const fechaInicio = $(document.getElementById('fechaInicio'));
        const fechaFinal = $(document.getElementById('fechaFinal'));
        const dateOptions = { format: 'dd/mm/yyyy', autoclose: true, language: 'es' };

        
        fechaInicio.datepicker(dateOptions).on('changeDate', (e) => {
            fechaFinal.datepicker('setStartDate', e.date);
            this.setState({ fechaInicio: Moment(e.date).format('DD/MM/YYYY'), fechaInicioAux: Moment(e.date).format('L') });
        });

        fechaFinal.datepicker(dateOptions).on('changeDate', (e) => {
            fechaInicio.datepicker('setEndDate', e.date);
            this.setState({ fechaFinal: Moment(e.date).format('DD/MM/YYYY'), fechaFinalAux: Moment(e.date).format('L') });
        });


        //fechaFinal.datepicker('setStartDate', Moment(new Date(this.state.fechaInicio)).format('L'));
        //fechaInicio.datepicker('setEndDate', Moment(new Date(this.state.fechaFinal)).format('L'));


    }

    onAplicar() {
        this.setState({ disabled: true });
        var Aplicar = false;
        for (let i = 0; i < this.state.SelectedList.length; i++) {
            if (this.state.SelectedList[i].Aplicar) {
                Aplicar = this.state.SelectedList[i].Aplicar;
            }

        }
        if (Aplicar) {
            Aplicar_Cola_Venta_Credito_Fiscal({ pDatos: this.state.SelectedList })
                .then(({ data: Response }) => {
                    const { Message, Data } = Response;
                    if (Message !== '') {
                        alert(Message);
                        this.setState({ disabled: false });
                    } else {
                        this.cargar_Cola_Venta_Credito_Fiscal();
                        this.setState({ disabled: false });
                        alert('La operación ya fue actualizada.');
                    }
                })
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
        } else {
            this.setState({ disabled: false });
            alert('Debe seleccionar un documento.');
        }
    }

    onAplicarTodo() {
        Aplicar_Todo_Cola_Venta_Credito_Fiscal()
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    this.cargar_Cola_Venta_Credito_Fiscal();
                    this.setState({ disabled: false });
                    alert('La operación ya fue actualizada.');
                }
            })
            .catch((err) => { console.log(err); });
    }

    onVentaCredito() {
        this.cargar_Cola_Venta_Credito_Fiscal();
    }

    onCancelaciones() {
        this.cargar_Cancelaciones();
    }

    onNotaCredito() {
        this.cargar_Nota_Credito();
    }

    onClickTable(row, $element, field) {
        const selectedRow = document.querySelector('tr.table-info');
        if (!!selectedRow)
            selectedRow.classList.remove('table-info');
        if ($element.Factura_Id > 0) {
            document.querySelector(`tr[data-id="${$element.Documento}"]`).classList.add('table-info');
        }
        this.setState({ selectedRow: $element });
        for (let i = 0; i < this.state.SelectedList.length; i++) {
            if ($element.Documento == this.state.SelectedList[i].Documento) {
                this.state.SelectedList[i].Aplicar = field.prevObject[0].firstChild.checked;
            }
            
        }
    }
    
    render() {

        const { baseUrl, disabled, estiloFactura, estiloCancelacion, estiloNota  } = this.state;
        //const OptionsPago = formasdePago.map(item => ({ value: Id, label:Nombre }))
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
        return (
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-md-12">
                            <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right" style={linkStyle}>
                                <i className="fas fa-angle-double-left"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onVentaCredito}>
                                <i>Venta Crédito</i>
                            </button>
                            <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onCancelaciones}>
                                <i>Cancelaciones</i>
                            </button>
                            <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onNotaCredito}>
                                <i>Nota Crédito</i>
                            </button>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="form-inline col-md-10" id="fechas">
                            <div className="form-group col-md-6">
                                <label>Fecha Inicial</label>
                                <input type="text" name="fechaInicio" id="fechaInicio" className="form-control datepicker" value={this.state.fechaInicio} onChange={this.onchangeFechas} readOnly />
                            </div>
                            <div className="form-group col-md-6">
                                <label>Fecha Final</label>
                                <input type="text" name="fechaFinal" id="fechaFinal" className="form-control" value={this.state.fechaFinal} onChange={this.onchangeFechas} readOnly />
                            </div>
                        </div>
                    </div>
                    

                    <div className="row" style={{ display: estiloFactura ? "block" : "none" }}>
                        <div className="col-md-12">
                            <table ref="tblFacturas"></table>
                        </div>
                    </div>

                    <div className="row" style={{ display: estiloCancelacion ? "block" : "none" }}>
                        <div className="col-md-12">
                            <table ref="tblCancelaciones"></table>
                        </div>
                    </div>

                    <div className="row" style={{ display: estiloNota ? "block" : "none" }}>
                        <div className="col-md-12">
                            <table ref="tblNotaCredito"></table>
                        </div>
                    </div>
                </div>
                <div id="toolbar">
                    <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onAplicar}>
                        <i className={disabled ? 'fas fa-spinner fa-spin' : 'fas fa-clipboard-check'}></i>
                    </button>
                    <button type="button" className="btn btn-custom-theme ml-1" disabled={disabled} onClick={this.onAplicarTodo}>
                        <i>Todo</i>
                    </button>
                </div>
                
              
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/bitacora/index.jsx